<template>
<div class="chapter">
<div class="inner_page">
<p><br/>
<br/>
<br/>
<br/></p>
<div class="pageno" id="Page_1" title="- 1 -"></div>
<div class="figcenter"><img alt="Decoration" height="133" src="Images/003.jpg" title="" width="500"/></div>
<p><br/>
<br/></p>
<h1 class="sigil_not_in_toc" id="pgepubid00023">OUT ON THE PAMPAS;</h1>
<h5 class="sigil_not_in_toc">OR,</h5>
<h2 class="sigil_not_in_toc" id="pgepubid00024">THE YOUNG SETTLERS.</h2>
<p class="center xsmfont">——♦——</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// main_0003.vue?2882d4d2